const store = {
    namespaced: true,
    state() {
        return {
            mainPageAdvantagesData: [],
            productPageAdvantagesData: [],
            categoryPageAdvantagesData: [],
            isAdvantagesDataFetching: false
        };
    },
    getters: {
        getMainPageAdvantagesData: state => state.mainPageAdvantagesData,
        getProductPageAdvantagesData: state => state.productPageAdvantagesData,
        getCategoryPageAdvantagesData: state => state.categoryPage,
        getIsAdvantagesDataFetching: state => state.isAdvantagesDataFetching
    },
    mutations: {
        SET_MAIN_PAGE_ADVANTAGES_DATA: (state, data) => (state.mainPageAdvantagesData = data),
        SET_PRODUCT_PAGE_ADVANTAGES_DATA: (state, data) => (state.productPageAdvantagesData = data),
        SET_CATEGORY_PAGE_ADVANTAGES_DATA: (state, data) => (state.categoryPageAdvantagesData = data),
        SET_IS_ADVANTAGES_DATA_FETCHING: (state, data) => (state.isAdvantagesDataFetching = data)
    },
    actions: {
        fetchMainPageAdvantagesData: async function ({ commit }, data) {
            commit('SET_IS_ADVANTAGES_DATA_FETCHING', true);
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/advantage/main_page/`
                });

                commit('SET_MAIN_PAGE_ADVANTAGES_DATA', res.data.advantages);
            } catch (error) {
                console.error(error);
            } finally {
                commit('SET_IS_ADVANTAGES_DATA_FETCHING', false);
            }
        },
        fetchProductPageAdvantagesData: async function ({ commit }, data) {
            commit('SET_IS_ADVANTAGES_DATA_FETCHING', true);
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/advantage/product_page/`
                });

                commit('SET_PRODUCT_PAGE_ADVANTAGES_DATA', res.data.advantages);
            } catch (error) {
                console.error(error);
            } finally {
                commit('SET_IS_ADVANTAGES_DATA_FETCHING', false);
            }
        },
        fetchCategoryPageAdvantagesData: async function ({ commit }, data) {
            commit('SET_IS_ADVANTAGES_DATA_FETCHING', true);
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/advantage/category_page/`
                });

                commit('SET_CATEGORY_PAGE_ADVANTAGES_DATA', res.data.advantages);
            } catch (error) {
                console.error(error);
            } finally {
                commit('SET_IS_ADVANTAGES_DATA_FETCHING', false);
            }
        }
    }
};

export default store;
